const STYLE = {
    requested: ["bg-amber-100 text-amber-800", "Awaiting quote"],
    quoted: ["bg-blue-100 text-blue-800", "Quote ready"],
    accepted: ["bg-emerald-100 text-emerald-800", "Accepted"],
    declined: ["bg-slate-200 text-slate-600", "Declined"],
};

export const QuoteStatusPill = ({ status }) => {
    const [cls, label] = STYLE[status] || STYLE.requested;
    return <span className={`px-2 py-0.5 rounded-full text-[10px] font-black uppercase tracking-wider ${cls}`} data-testid="planner-quote-status">{label}</span>;
};
